import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
import { EmptyState } from "../../../../../components/emptyState/emptyState";
import AccountTableCell from "./AccountTableCell";
import TotalTableRow from "./TotalTableRow";

const ReportTable = ({
  columns,
  emptyMessage = "Sem dados",
  errorMessage,
  data,
  isConsolidated,
}) => {
  const ref = useRef(null);

  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  useEffect(() => {
    function handleWindowResize() {
      setHeight(ref.current.clientHeight);
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <TableContainer style={{ maxHeight: "70vh", height: "100%" }}>
      <Table aria-label="customized table" stickyHeader>
        <TableHead>
          <TableRow ref={ref}>
            {columns.map((column) => (
              <TableCell
                align={column.align}
                key={column.id}
                style={{
                  backgroundColor: "#d6e5ff",
                  fontSize: "0.875rem",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {errorMessage ? (
            <TableRow>
              <TableCell align="center" colSpan={columns.length}>
                {errorMessage}
              </TableCell>
            </TableRow>
          ) : data?.length ? (
            data?.map((cell) => {
              const formatedPeriodGroup = {
                day: moment(cell?.period?.startDate, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                ),
                week: `${moment(cell?.period?.startDate, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                )} - ${moment(cell?.period?.endDate, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                )}`,
                month: moment(cell?.period?.startDate, "YYYY-MM-DD").format(
                  "MM/YYYY"
                ),
              };

              return isConsolidated ? (
                <TotalTableRow
                  cell={cell}
                  totalLabel={formatedPeriodGroup[cell?.period?.type ?? "day"]}
                  labelColspan={columns.length - 3}
                />
              ) : (
                <>
                  <TableRow
                    style={{
                      position: "sticky",
                      top: height,
                    }}
                  >
                    <TableCell
                      align="left"
                      colSpan={columns.length}
                      style={{
                        backgroundColor: "#d9edf7",
                      }}
                    >
                      {formatedPeriodGroup[cell?.period?.type ?? "day"]}
                    </TableCell>
                  </TableRow>

                  {cell?.accounts?.map((groupedCell) => (
                    <TableRow key={cell.identifier}>
                      {columns.map((column) => (
                        <AccountTableCell
                          align={column.align}
                          id={column.id}
                          data={
                            column.format
                              ? column.format(groupedCell[column.id])
                              : groupedCell[column.id]
                          }
                          key={column.id}
                        />
                      ))}
                    </TableRow>
                  ))}

                  <TotalTableRow
                    cell={cell}
                    totalLabel={"Totais:"}
                    labelColspan={columns.length - 3}
                  />
                </>
              );
            })
          ) : (
            <TableRow>
              <TableCell align="center" colSpan={columns.length}>
                <EmptyState message={emptyMessage} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default memo(ReportTable);
